import { format } from 'date-fns';

import type { ITableSorting } from '@model/tableSorting';

import type { ICartRange, IFilter } from '../model/engagementFilter';

export const getRequestParams = ({
  filter,
  locationIds,
  cartRange,
  sorting,
}: {
  filter: IFilter;
  cartRange?: ICartRange;
  locationIds: Array<number>;
  sorting?: ITableSorting;
}) => {
  const timeCreatedRange =
    filter.minTimeCreated && filter.maxTimeCreated
      ? `${format(filter.minTimeCreated, 'MM/dd/yyyy')} - ${format(filter.maxTimeCreated, 'MM/dd/yyyy')}`
      : undefined;

  const filterParams = {
    time_created_range: timeCreatedRange,
    location_ids: locationIds,
    states: filter.states ? filter.states : [],
    type: filter.type === 'all' ? undefined : filter.type,
    urgency: filter.urgency === 'all' ? undefined : filter.urgency,
    with_customer_reported_failures: +filter.reportedFailure,
    ...(cartRange && { cart_range: { min_cart: cartRange.minCart, max_cart: cartRange.maxCart } }),
    ...(filter.metricType && { metric_type: filter.metricType }),
    ...(filter.facilityIds && { location_id: filter.facilityIds }),
  };

  if (filter.states) {
    const filterState = filter.states;

    const isFilterState9 = filterState.includes(9);
    const isFilterState5 = filterState.includes(5);

    if (isFilterState9 !== isFilterState5) {
      if (isFilterState9) {
        filterParams.states.push(5);
      } else {
        filterParams.states = filterState.filter((s) => +s !== 5);
      }
    }
  }

  if (sorting) {
    const orderBy = sorting.id ? sorting.id : undefined;
    const direction = !sorting.id ? undefined : sorting.desc ? 'desc' : 'asc';

    const sortParams = {
      field: orderBy,
      direction: direction,
    };

    return { filterParams, sortParams };
  }

  return { filterParams };
};
